import React from "react";
import { useSelector } from "react-redux";
import Tick from "../../../Assets/Icons/bluecheckmark.svg";
import PrimaryButton from "../../common/PrimaryButton";
import PrimaryOutlineButton from "../../common/PrimaryOutlineButton";
import Loader from "../../common/Loader";
import CrownIcon from "../../../Assets/Icons/crown.svg";
import RocketIcon from "../../../Assets/Icons/rocket.svg";

const SubscriptionPlan = ({
  title,
  plans,
  price,
  duration,
  joinClick,
  cancelOption,
  cancelClick,
}) => {
  const loading = useSelector((state) => state.subscriptionReducer.loading);
  
  const isYearly = String(duration).toLowerCase().includes("year") || 
                   String(duration).toLowerCase().includes("12") ||
                   String(title).toLowerCase().includes("premium") ||
                   String(title).toLowerCase().includes("year");
  
  const priceUnit = isYearly ? "/year" : "/month";
  const subtitle = isYearly
    ? "Simple, one-time payment"
    : "Flexible, pay monthly";

  const displayPrice = price || (isYearly ? "49.99" : "4.16");

  return (
    <>
      <div
        className="bg-white rounded-[12px] w-[82%] sm:w-[36%] md:w-[30%] lg:w-[23%] 2xl:w-[21%] min-h-[500px] border border-[#E6E6E6] shadow-[0_4px_10px_rgba(0,0,0,0.08)]"
      >
        {loading && <Loader />}

        <div className="flex items-center justify-between px-4 pt-4">
          <div className="flex items-center justify-center text-[#00ADEF]">
            {isYearly ? (
              <img src={CrownIcon} alt="yearly" className="w-9 h-9" />
            ) : (
              <img src={RocketIcon} alt="monthly" className="w-9 h-9" />
            )}
          </div>
          <span className="text-[12px] font-[600] text-white bg-[#00ADEF] px-4 py-1.5 rounded-full">
            Individual Plan
          </span>
        </div>

        {/* Title and subtitle */}
        <div className="px-4 mt-4">
          <p className="text-[#303030] text-[19px] font-[600]">{title}</p>
          <p className="text-[#303030] text-[13px] mt-1 mb-3">{subtitle}</p>
        </div>

        {/* Price block */}
        <div className="px-4 mt-3">
          {/* <span className="text-[32px] font-[600] text-[#303030]">${displayPrice}</span>
          <span className="ml-1 text-[14px] text-[#303030] relative -top-0.5">{priceUnit}</span> */}
          <div className="text-[13px] text-[#303030] mt-1">
            Cost saving, cost effective
          </div>
        </div>

        {/* CTA */}
        <div className="px-4 mt-4">
          {cancelOption === true ? (
            <PrimaryOutlineButton
              label={"Cancel Subscription"}
              className="w-full text-[14px] font-[600] h-[40px] rounded-[8px]"
              onClick={cancelClick}
            />
          ) : (
            <PrimaryButton
              // label={duration?.toLowerCase()?.includes("year") ? "Buy Subscription" : "Buy Subscription"}
                   label={duration?.toLowerCase()?.includes("year") ? "Activate Membership" : "Activate Membership"}
              className="w-[95%] ml-auto text-[14px] font-[600] h-[40px] rounded-[8px]"
              onClick={joinClick}
            />
          )}
        </div>

        {/* Features */}
        <div className="px-4 pb-2 mt-5">
          <p className="text-[16px] text-[#303030]">
            Everything on <span className="font-[700] text-[#303030]">{title}</span>:
          </p>
          <div className="mt-3">
            {[
              "Many offers available",
              "Benefits and savings",
              "1 year membership",
              "Exclusive experiences",
              "Digital & easy",
            ].map((plan, idx) => (
              <div key={idx} className="flex gap-2 mb-2 items-start">
                <img src={Tick} className="w-[19px] mt-[3px]" alt="tick" />
                <p className="text-[16px] text-[#303030]">{plan}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionPlan;
